import { getCountForFieldEQLFunction } from '@modules/common/utils/getCountForFieldEQLFunction';
import { FieldNames } from 'v2/core/entities/fields';

interface isCountForFunctionRequiredParams {
  eqlFieldName?: FieldNames;
  variant: 'chart' | 'table';
  shouldShowAllValues: boolean;
  shouldShowTopDataPoints?: boolean;
  visibleDataPoints?: string[];
}

export function isCountForFunctionRequired({
  eqlFieldName,
  shouldShowAllValues,
  shouldShowTopDataPoints,
  variant,
  visibleDataPoints = [],
}: isCountForFunctionRequiredParams) {
  const countForLabelsFunc = getCountForFieldEQLFunction(eqlFieldName);
  const shouldFetchVisibleDataPoints =
    variant === 'table' ? !shouldShowAllValues : visibleDataPoints.length > 0;

  const shouldUseCountForFunction =
    !shouldShowTopDataPoints &&
    shouldFetchVisibleDataPoints &&
    countForLabelsFunc;

  return shouldUseCountForFunction;
}
